/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_Form_Field_MessageInputs */

const tr_contact_form_field_message = /** @type {(inputs: Contact_Form_Field_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mesaj *`)
};

const en_contact_form_field_message = /** @type {(inputs: Contact_Form_Field_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Message *`)
};

const de_contact_form_field_message = /** @type {(inputs: Contact_Form_Field_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nachricht *`)
};

const ru_contact_form_field_message = /** @type {(inputs: Contact_Form_Field_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сообщение *`)
};

/**
* | output |
* | --- |
* | "Message *" |
*
* @param {Contact_Form_Field_MessageInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const contact_form_field_message = /** @type {((inputs?: Contact_Form_Field_MessageInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_Form_Field_MessageInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_contact_form_field_message(inputs)
	if (locale === "de") return de_contact_form_field_message(inputs)
	if (locale === "ru") return ru_contact_form_field_message(inputs)
	return tr_contact_form_field_message(inputs)
});